import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { extractProperty, getNonUmbracoUrl, Link } from "utils"

type Props = {
  item: any
}

const StyledItemDiv = styled.div`
  padding: 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  img {
    border-radius: 8px;
  }
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
`

const StyledItemHeaderDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`
const StyledText = styled(Typography)`
  padding-top: 16px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  padding-top: 16px;
`

const StyledLinkWrapper = styled.div`
  min-height: 64px;
  display: flex;
  align-items: flex-end;
`

const RecommendationItem = ({ item }: Props) => {
  const image = extractProperty(item, "image")
  const title = extractProperty(item, "title")
  const role = extractProperty(item, "role")
  const text = extractProperty(item, "text")
  const linkedinLink = extractProperty(item, "linkedinLink")
  const linkedinIcon = extractProperty(item, "linkedinIcon")

  return (
    <StyledItemDiv>
      <StyledItemHeaderDiv>
        <Image
          src={getNonUmbracoUrl(image)}
          width={84}
          height={84}
          alt={title}
        />
        <div>
          <Typography variant="subtitle1">{title}</Typography>
          <Typography variant="body2">{role}</Typography>
        </div>
      </StyledItemHeaderDiv>
      <StyledText
        variant="body2"
        style={{
          borderBottom: "1px solid #D1D5DB",
          paddingBottom: "24px",
          flex: 1,
        }}
      >
        {text}
      </StyledText>
      <StyledLinkWrapper>
        {linkedinLink?.[0]?.url && (
          <StyledLink
            href={getNonUmbracoUrl(linkedinLink?.[0]?.url)}
            target="_blank"
          >
            {linkedinIcon && (
              <Image
                src={getNonUmbracoUrl(linkedinIcon)}
                width={32}
                height={32}
                alt="linkedin"
              />
            )}
            <Typography variant="body2"> {linkedinLink?.[0]?.name}</Typography>
          </StyledLink>
        )}
      </StyledLinkWrapper>
    </StyledItemDiv>
  )
}

export default RecommendationItem
